import { createAction, props } from '@ngrx/store';
import { AuthResponse } from '@app/features/login/interfaces/authResponse.interface';
import { User } from '@app/core/interfaces/user.interface';
import { LogoutType } from '@app/core/enums/logout-types.enum';


export const ImpersonateSuccess = createAction(
  '[Admin] Impersonate User',
  props<{ response: AuthResponse; }>()
);

export const StopImpersonation = createAction(
  '[Admin] Stop Impersonating User',
  props<{ user: User | null }>()
);

export const LoginSuccess = createAction(
  '[UserAuth] Login Success',
  props<{ response: AuthResponse; }>()
);

export const LoginFailure = createAction(
  '[UserAuth] Login Failure',
  props<{ error: string; data?: string[]}>()
);

export const ResetPasswordFailure = createAction(
  '[UserAuth] Reset Password Failure',
  props<{ error: string; }>()
);

export const ResetPasswordSuccess= createAction(
  '[UserAuth] Reset Password Success',
  props<{ response: string; }>()
);

export const ChangePasswordRequested = createAction(
  '[UserAuth] Change Password Requested',
  props<{ accessToken: string; oldPassword: string; newPassword: string; confirmPassword: string; }>()
);

export const ChangePasswordSuccess = createAction(
  '[UserAuth] Change Password Success',
  props<{ response: string; }>()
);

export const ChangePasswordFailure = createAction(
  '[UserAuth] Change Password Failure',
  props<{ error: string; }>()
);

export const LogoutFailure = createAction(
  '[Auth] Logout Failure',
  props<{ error: any; }>()
);

export const LogoutRequested = createAction(
  '[UserAuth] Logout Requested',
  props<{ logoutType: LogoutType }>()
);

export const LogoutSuccess = createAction(
  '[UserAuth] Logout Success',
  props<{ logoutType: LogoutType }>()
);

export const SessionExpired = createAction(
  '[UserAuth] Session Expired',
  props<{ logoutType: LogoutType }>()
);

export const LogoutOnAlternateTab = createAction(
  '[UserAuth] Logout On Alternate Tab',
  props<{ logoutTime: string }>()
);

export const UpdateUserAuthDetails = createAction(
  '[UserAuth] Updating User Auth Details',
  props<{ isAuthenticated: boolean, user: User | null, isImpersonating: boolean }>()
);

export const DefaultRouteRequested = createAction(
  '[UserAuth] Default Route Requested',
  props<{ user: User | null, returnUrl?: string }>()
);

export const EffectiveUserChanged = createAction(
  '[UserAuth] Authenticated User',
  props<{ user: User | null }>()
);

export const ImpersonationRequested = createAction(
  '[UserAuth] Impersonation Requested',
  props<{ impersonatedUserId: string }>()
);
